import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import * as Turbo from "@hotwired/turbo";

const StandaloneTranslationDropDown = lazy(() =>
  import("../../components/shared/TranslationDropDown").then((module) => ({
    default: module.StandaloneTranslationDropDown,
  })),
);

// Connects to data-controller="shared--translation-dropdown"
export default class extends Controller {
  static values = {
    lang: String,
    url: String,
  };

  connect() {
    const props = {
      handleLanguageSelect: this.handleLanguageSelect,
      object_language: this.langValue,
    };

    this.root = createRoot(this.element);
    this.root.render(
      <Suspense fallback={null}>
        <StandaloneTranslationDropDown {...props} />
      </Suspense>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }

  handleLanguageSelect = (event, language) => {
    event.preventDefault();
    const newUrl = this.urlValue.replace(":locale", language.toLowerCase());
    Turbo.visit(newUrl);
  };
}
